import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatIncident',
})
export class FormatIncidentPipe implements PipeTransform {
  transform(number?: number): any {
    return 'OK-' + number;
  }
}
